// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L6cZ","col":"styles_col__1JIw5"};